module.exports = "<button class=\"btn btn-primary button-base-pdf\"\r\n        (click)=\"onClickHandler($event, pdfId, name)\">\r\n    {{ compactString(name) }}\r\n</button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/base-pdf/base-pdf.component.html
// module id = ./src/app/commons/base-pdf/base-pdf.component.html
// module chunks = main